import React from "react";

const SvgColdOff = props => (
  <svg width={40} height={40} {...props}>
    <path
      d="M20.369 3.096v33.5M15.44 6.878l4.93 3.007 4.93-3.007m0 26.212l-4.93-3.007-4.93 3.007M5.919 11.383l28.9 16.926M6.684 17.546l5.09-2.731-.106-5.78m22.62 13.249l-5.09 2.731.107 5.78m5.599-19.274L5.951 28.372m23.205-19.21l-.117 5.77 5.08 2.752M11.466 30.87l.117-5.77-5.08-2.741"
      fill="none"
      fillRule="evenodd"
      stroke="#FDFDFE"
      strokeLinecap="round"
      strokeWidth={1.8}
      opacity={0.4}
    />
  </svg>
);

export default SvgColdOff;
